<script setup lang="ts">
const startTransition = (element: Element) => {
  const elementStyle = (element as HTMLElement).style

  elementStyle.height = `${element.scrollHeight}px`
}

const endTransition = (element: Element) => {
  const elementStyle = (element as HTMLElement).style

  elementStyle.height = ''
}
</script>

<template>
  <transition
    name="height"
    @enter="startTransition"
    @after-enter="endTransition"
    @before-leave="startTransition"
    @after-leave="endTransition"
  >
    <slot />
  </transition>
</template>

<style lang="scss" scoped>
.height-enter-active,
.height-leave-active {
  overflow: hidden;
  transition: height 0.3s ease, opacity 0.3s ease;
  will-change: height, opacity;
}

.height-enter-from,
.height-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
